import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initAnalytics } from "./analytics";

// Before render, so the first pageview is not lost to a race with the router. A no-op
// when VITE_POSTHOG_KEY is unset, which is the default in a fresh checkout.
initAnalytics();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
